import React from 'react'
import PropTypes from 'prop-types'
import { StyledCloseButton, StyledCloseImage } from './styles'
import TimesIconBlack from '../../../images/icon_times_black.svg'

export const CloseButton = ({ onClick }) => {
  return (
    <div>
      <StyledCloseButton>
        <StyledCloseImage src={TimesIconBlack} onClick={onClick} />
      </StyledCloseButton>
    </div>
  )
}

CloseButton.defaultProps = {
  onClick: null,
}

CloseButton.propTypes = {
  onClick: PropTypes.func,
}
